module.exports = {
	"config": {
		"blogTitle": "Left Fold",
		"authorName": "Keith Alexander",
		"linkPrefix": "/"
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.js",
				"ext": "js",
				"name": "_template",
				"extname": ".js",
				"basename": "_template.js",
				"dirname": "",
				"stem": "_template",
				"path": "_template.js",
				"absolute": "/Users/keith/kwijibo-pages/gatsby-blog/_template.js",
				"isAbsolute": false
			},
			"requirePath": "_template.js",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-01-23-maybes",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "2017-01-23-maybes",
				"stem": "index",
				"path": "2017-01-23-maybes/index.md",
				"absolute": "/Users/keith/kwijibo-pages/gatsby-blog/2017-01-23-maybes/index.md",
				"isAbsolute": false
			},
			"requirePath": "2017-01-23-maybes/index.md",
			"path": "/uncertain-values/",
			"data": {
				"title": "Programming with Uncertain Values",
				"date": "2017-01-23T22:40:32.169Z",
				"path": "/uncertain-values/",
				"readNext": "/maybe-empty-task/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "2017-01-25-alts.md",
				"ext": "md",
				"name": "2017-01-25-alts",
				"extname": ".md",
				"basename": "2017-01-25-alts.md",
				"dirname": "",
				"stem": "2017-01-25-alts",
				"path": "2017-01-25-alts.md",
				"absolute": "/Users/keith/kwijibo-pages/gatsby-blog/2017-01-25-alts.md",
				"isAbsolute": false
			},
			"requirePath": "2017-01-25-alts.md",
			"path": "/fallbacks-alt/",
			"data": {
				"title": "Fallbacks with Alt",
				"path": "/fallbacks-alt/",
				"readNext": "/maybe-empty-task"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "2017-02-01-task-maybe-transformation.md",
				"ext": "md",
				"name": "2017-02-01-task-maybe-transformation",
				"extname": ".md",
				"basename": "2017-02-01-task-maybe-transformation.md",
				"dirname": "",
				"stem": "2017-02-01-task-maybe-transformation",
				"path": "2017-02-01-task-maybe-transformation.md",
				"absolute": "/Users/keith/kwijibo-pages/gatsby-blog/2017-02-01-task-maybe-transformation.md",
				"isAbsolute": false
			},
			"requirePath": "2017-02-01-task-maybe-transformation.md",
			"path": "/task-maybes/",
			"data": {
				"title": "Working with Tasks containing Maybes: another empty Future",
				"date": "2017-02-01",
				"readNext": "/fallbacks-alt/",
				"path": "/task-maybes/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md",
				"absolute": "/Users/keith/kwijibo-pages/gatsby-blog/404.md",
				"isAbsolute": false
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "",
				"stem": "index",
				"path": "index.js",
				"absolute": "/Users/keith/kwijibo-pages/gatsby-blog/index.js",
				"isAbsolute": false
			},
			"requirePath": "index.js",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "maybe-future-empty.md",
				"ext": "md",
				"name": "maybe-future-empty",
				"extname": ".md",
				"basename": "maybe-future-empty.md",
				"dirname": "",
				"stem": "maybe-future-empty",
				"path": "maybe-future-empty.md",
				"absolute": "/Users/keith/kwijibo-pages/gatsby-blog/maybe-future-empty.md",
				"isAbsolute": false
			},
			"requirePath": "maybe-future-empty.md",
			"path": "/maybe-empty-task/",
			"data": {
				"title": "How to handle an uncertain Future, with Task.empty",
				"path": "/maybe-empty-task",
				"readNext": "/task-maybes/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "my-first-react-component-what-i-did-wrong.md",
				"ext": "md",
				"name": "my-first-react-component-what-i-did-wrong",
				"extname": ".md",
				"basename": "my-first-react-component-what-i-did-wrong.md",
				"dirname": "",
				"stem": "my-first-react-component-what-i-did-wrong",
				"path": "my-first-react-component-what-i-did-wrong.md",
				"absolute": "/Users/keith/kwijibo-pages/gatsby-blog/my-first-react-component-what-i-did-wrong.md",
				"isAbsolute": false
			},
			"requirePath": "my-first-react-component-what-i-did-wrong.md",
			"path": "/my-first-react-component-what-i-did-wrong/",
			"data": {
				"title": "What I did Wrong with my first React Component",
				"date": "2016-09-13",
				"path": "/my-first-react-component-what-i-did-wrong"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "task-monad-in-javascript.md",
				"ext": "md",
				"name": "task-monad-in-javascript",
				"extname": ".md",
				"basename": "task-monad-in-javascript.md",
				"dirname": "",
				"stem": "task-monad-in-javascript",
				"path": "task-monad-in-javascript.md",
				"absolute": "/Users/keith/kwijibo-pages/gatsby-blog/task-monad-in-javascript.md",
				"isAbsolute": false
			},
			"requirePath": "task-monad-in-javascript.md",
			"path": "/task-monad-in-javascript/",
			"data": {
				"title": "The Task Monad in Javascript: pure asynchronous effects you can compose",
				"path": "/task-monad-in-javascript"
			}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 382
// module chunks = 0